import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function DeviceLink() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{t("deviceLink")}</h1>
        <p className="text-muted-foreground">
          Link your GPSBox device to your account
        </p>
      </div>

      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Link New Device</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Device linking form will be implemented here.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
